<template>
    <div class="competence-curve">

        <svg
            width="100%"
            preserveAspectRatio="none"
        >
<!--            d="M0,0 C45,0 45,192 89,192 "-->
            <path
                :d="`M${pointStart[0]},${pointStart[1]} C${width/2},${pointStart[1]} ${width/2},${pointEnd[1]} ${pointEnd[0]},${pointEnd[1]}`"
                style="stroke:#D2D5D9; stroke-width:2; fill:none;"
            />
        </svg>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const trackGetters = [
    'getCompetenceLevels',
];
export default {
    name: 'SoftCompetenceCurve',
    data: ()=>({
        height: 192,
        width: 89,
    }),
    props: {
        prevCompetenceLevel: String,
        nextCompetenceLevel: String,
    },
    computed: {
        ...mapGetters('accountTrack', trackGetters),
        points() {
            let count = this.getCompetenceLevels.length;
            let maxY = this.height;
            let maxX = this.width;
            let period = maxY / count;
            return {
                startPoints: this.getCompetenceLevels.map((v, index) => {
                    return [0, (maxY / ( 2 * count)) + (period * (count-index - 1))];
                }),
                endPoints: this.getCompetenceLevels.map((v, index) => {
                    return [maxX, (maxY / ( 2 * count)) + (period * (count-index - 1))];
                }),
            };
        },
        pointStart() {
            return this.points.startPoints[this.numberEnd(this.prevCompetenceLevel)];
        },
        pointEnd() {
            return this.points.endPoints[this.numberEnd(this.nextCompetenceLevel)];
        },
    },
    methods: {
        numberEnd(level) {
            return this.getCompetenceLevels.length - this.getCompetenceLevels.findIndex(v => v.key === level) - 1;
        },
    },
};
</script>

<style lang="scss" scoped>
.competence-curve{
    width: 89px;
    height: 100%;
    svg{
        width: 100%;
        height: 100%;
    }
}
</style>